import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#alignment" }),
  /*#__PURE__*/_createTextVNode(" Alignment ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Setting this attribute can adjust the alignment of child nodes, the desirable value can be found at align-items. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { style: {"width":"256px","margin-bottom":"20px","padding":"8px","border":"1px solid #ccc"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" string ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" button ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" header ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" body ")
const _hoisted_10 = { style: {"width":"256px","margin-bottom":"20px","padding":"8px","border":"1px solid #ccc"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" string ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" button ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" header ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" body ")
const _hoisted_15 = { style: {"width":"256px","margin-bottom":"20px","padding":"8px","border":"1px solid #ccc"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" string ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" button ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" header ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" body ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, null, {
              header: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_el_space, { alignment: "flex-start" }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, null, {
              header: _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_el_space, { alignment: "flex-end" }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, null, {
              header: _withCtx(() => [
                _hoisted_18
              ]),
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}